export default __webpack_public_path__ + "static/media/explorers-on-rock.f392091e.jpg";